import { AxiosResponse } from 'axios';

import { DraggablePhotos } from '../shared';

import {
    ImageFileUploading,
    onSelectPhoto,
    OptionalData,
} from '../utils/upload';

import { MediaType } from '../types/enums/mediatype.enum';

import { Media } from '../types/mediaTypes';
import { Pack } from '../types/packTypes';

import wormImg from '../assets/worm.png';

type ThumbnailProps = {
    type: MediaType;
    id: Pack['packId'];
    items: (Media | (ImageFileUploading & { id?: number }))[];
    onSelect: (
        type: MediaType,
        items: ImageFileUploading[],
        optionalData: OptionalData,
    ) => void;
    onUpload: (
        type: MediaType,
        file: File,
        res: AxiosResponse<{ uploaded: Media }>,
    ) => void;
    onDelete: (index: number, type: MediaType) => void;
    onDragPhotoEnd: (result: {
        source: { index: number; droppableId: MediaType };
        destination: { index: number };
    }) => void;
    isMultiple: boolean;
    onProcessingComplete?: (media: Media) => void;
    onProcessingError?: (mediaId: number) => void;
};

function Thumbnail(props: ThumbnailProps) {
    const {
        items,
        id,
        type,
        onSelect,
        onUpload,
        onDelete,
        isMultiple,
        onDragPhotoEnd,
        onProcessingComplete,
        onProcessingError,
    } = props;

    return (
        <div>
            {items.length === 0 && (
                <div className="noMediaWrapper">
                    <img
                        alt="placeholder no screenshots uploaded"
                        src={wormImg}
                    ></img>
                    <label className="placeholder">
                        No {type == MediaType.IAP_IMAGE ? 'image' : 'thumbnail'}
                        , just yet. Drag and drop here to upload :)
                    </label>
                </div>
            )}
            <DraggablePhotos
                onDelete={onDelete}
                type={type}
                items={items}
                onDragEnd={onDragPhotoEnd}
                onProcessingComplete={onProcessingComplete}
                onProcessingError={onProcessingError}
            />
            <div style={{ marginTop: 20 }}>
                <input
                    type="file"
                    name=""
                    id={id}
                    accept="Image/*"
                    onChange={(e) => onSelectPhoto(e, type, onSelect, onUpload)}
                    multiple={isMultiple}
                />
                <label className="upload" htmlFor={id}>
                    Add new
                </label>
            </div>
        </div>
    );
}

export default Thumbnail;
